export const headersWithToken = () => {
  const headers = new Headers()
  headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)
  return headers
}
